import { render, staticRenderFns } from "./FundingSplit.vue?vue&type=template&id=eec1344e&"
import script from "./FundingSplit.vue?vue&type=script&lang=js&"
export * from "./FundingSplit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports